/**
 * dcent-menu-viewport-reset.js — 모바일 메뉴를 연 채 PC 폭으로 넓히면 페이지가 잠기던 것 해제 (MAGE-463).
 *
 * 증상
 *   창을 모바일 폭으로 줄여 햄버거 메뉴를 연 뒤 다시 PC 폭으로 넓히면 스크롤바가 사라지고
 *   휠·드래그 스크롤이 전혀 먹지 않는다. 메뉴는 이미 화면에서 사라진 뒤라 사용자는 원인을 못 본다.
 *   dev 실측(2026-08-28, global): PC 복귀 후에도 <html>.prevent-scroll 잔존 ·
 *   html/body computed overflow = hidden · 휠 800px 굴려도 scrollY 0.
 *
 * 원인
 *   벤더 mega-menu.js 의 openMenu() 가 <html> 에 `prevent-scroll` 을 붙이고
 *   (snippets/critical-css.liquid: `html.prevent-scroll, html.prevent-scroll body { overflow:hidden }`),
 *   그걸 떼는 곳은 closeMenu() 뿐이다. closeMenu 로 가는 길은 햄버거 재클릭 · 백드롭 클릭 ·
 *   장바구니 열기 · 검색 열기 4개뿐이라 **뷰포트 폭이 바뀌는 경로가 없다**.
 *   드로어는 모바일 헤더(`.m-header__mobile`) 안에 있고 그 헤더는 header.css 에서
 *   `@media (min-width:1024px){ display:none }` 이라, 1024 이상에서는 햄버거도 백드롭도
 *   화면에서 사라진다 — 잠금만 남고 푸는 손잡이가 통째로 없어진다.
 *
 * 고치는 법
 *   창 크기가 바뀌어 **햄버거가 렌더 트리에서 사라진 순간** 열려 있던 드로어를 닫는다.
 *   - 폭(1024)을 여기 다시 적지 않는다 — header.css 가 바뀌면 조용히 어긋난다.
 *     `getClientRects().length === 0` 으로 "지금 이 버튼이 그려지고 있나"를 직접 본다.
 *   - 클래스를 손으로 벗기지 않고 **햄버거를 프로그램적으로 클릭**한다. 벤더 closeMenu() 가
 *     서브메뉴 클래스·`.active` 토글까지 한 벌로 정리하므로, 그 정리를 여기서 베끼면
 *     벤더가 바뀔 때 상태가 갈린다. click() 은 display:none 요소에도 그대로 먹는다.
 *   - 768~1023 구간은 건드리지 않는다. 거기선 모바일 헤더가 아직 보여서 사용자가 직접 닫을 수 있다.
 *
 * 벤더 파일(mega-menu.js)은 건드리지 않는다. 양 샵 byte-identical 미러(파리티 게이트 대상).
 */
(function () {
  var rafId = null;

  function isRendered(el) {
    // display:none 이 조상 어디에 걸려 있어도 rect 가 0개다. position:fixed 에 안 속는다(offsetParent 대비).
    return !!el && el.getClientRects().length > 0;
  }

  function closeDrawerIfUnreachable() {
    rafId = null;
    var drawer = document.getElementById("m-menu-drawer");
    if (!drawer || !drawer.classList.contains("open")) return;

    var button = document.querySelector(".m-menu-button");
    if (isRendered(button)) return; // 아직 사용자가 닫을 수 있는 폭이다

    if (button) {
      button.click(); // 벤더 Megamenu.closeMenu() 경로
      return;
    }
    // 햄버거 자체가 없는 예외 상황 — 드로어가 열려 있는 게 확실할 때만 최소한으로 정리한다.
    // 이 테마에서 prevent-scroll 을 붙이는 곳은 mega-menu.js 하나뿐이다(vendor.js 쪽 2건은 주석 처리됨).
    drawer.classList.remove("open");
    document.documentElement.classList.remove("prevent-scroll");
  }

  function schedule() {
    if (rafId !== null) return;
    rafId = window.requestAnimationFrame(closeDrawerIfUnreachable);
  }

  window.addEventListener("resize", schedule);
  window.addEventListener("orientationchange", schedule);
})();
